module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "href": "#/preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledge"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01"
    }
  }, [_vm._v("Scarborough Family Massacre: Louisville, 1816")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Arsenic Poisoning of Sarah Jane Gould: Louisville, 1858")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Almon Farnsworth’s Dreadful Death: Hermon, 1872")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Unfortunate Murder of Maria Shay: Ogdensburg, 1872")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Van Dyke’s Dubious Conviction: Oswegatchie, 1877")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frank Conroy, Wife Slasher: Ogdensburg, 1896")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Plot to Poison Joseph Kipp: Clifton, 1904")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jealous John Hall’s Violent End: Stockholm, 1905")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Apple-Crowder Double Homicide: Black Lake, 1908")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Harry Hosmer’s Fatal Bike Ride: Fine, 1908")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bloodbath at Buck Farm: Stockholm, 1917")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who Killed Bessie White? Massena, 1917")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0